<script>
    /**
     * Dependencies
     */
    import HelpText from '../HelpText'

    /**
     * Base Field Component
     */
    export default {
        name: 'base_field',
        components: {
            HelpText
        },
        props: {
            label: {
                type: String,
                required: false
            },
            value: {
                required: false,
                default: null
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            autofocus: {
                type: Boolean,
                required: false,
                default: false
            },
            focusOnRender: {
                type: Boolean,
                required: false,
                default: false
            },
            errors: {
                type: Array,
                required: false,
                default: () => []
            },
            required: {
                type: Boolean,
                required: false,
                default: false
            },
            helptext: {
                type: String,
                required: false,
                default: null
            }
        },
        data () {
            return {
                pristine: true
            }
        },
        methods: {
            updateValue (e) {
                this.$emit('updated', e.target.value)
            }
        },
        watch: {
            value (newVal) {
                if (this.hasErrors) {
                    this.$emit('clear-errors')
                }
            }
        },
        mounted () {
            if (this.focusOnRender) {
                this.$refs.input.focus()
            }
        },
        computed: {
            hasErrors () {
                return this.errors && this.errors.length > 0
            },
            fieldClasses () {
                return {
                    'has-errors': this.hasErrors || this.dirtyAndRequired
                }
            },
            labelClasses () {
                return {
                    'is-required': this.required
                }
            },
            noValue () {
                return this.value === null || this.value === 'undefined' || this.value === ''
            },
            dirtyAndRequired () {
                return this.required && !this.pristine && this.noValue
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/BaseField.vue